import { enumOrRaw } from '~/services/api/contracts/enumOrRaw'
import { MenuItemWeightUnitSchema } from '~/services/api/generated'

// Scramble documents only the backed-enum wire values; the server also accepts these full-word aliases.
const WEIGHT_UNIT_ALIASES: Readonly<Record<string, string>> = {
  gram: 'g',
  grams: 'g',
  kilogram: 'kg',
  kilograms: 'kg',
  ounce: 'oz',
  ounces: 'oz',
  pound: 'lb',
  pounds: 'lb'
}

export const normalizeWeightUnit = (value: unknown): unknown => {
  const matched = enumOrRaw(value, MenuItemWeightUnitSchema.options)
  if (MenuItemWeightUnitSchema.validate(matched)) return matched
  if (typeof value === 'string') {
    return WEIGHT_UNIT_ALIASES[value.trim().toLowerCase()] ?? matched
  }
  return matched
}
